import { Box } from 'braid-design-system';
import React from 'react';

import { useAppContext } from '../../../AppContext';

import Logo from './Logo/Logo';

import * as styles from './Header.css';

const Header = () => {
  const { site } = useAppContext();

  return (
    <Box
      className={styles.header}
      background={site === 'talent' ? 'brand' : 'surface'}
      data={{ testid: 'header' }}
    >
      <Logo />
    </Box>
  );
};

export default Header;
